export default __webpack_public_path__ + "static/media/element_15.1e01423b.jpg";